export default __webpack_public_path__ + "static/media/Pasuchaca.a7127c2f.jpeg";